import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "@pillvery/components/utility/loader";
import { routes } from "../../config/pillveryVariables";

import fetchSuppliersAction from "@pillvery/redux/suppliers/actions";
import fetchUsersAction from "@pillvery/redux/users/actions";

const { fetchSuppliers } = fetchSuppliersAction;
const { fetchUsers } = fetchUsersAction;

export default function LatestStatus(props) {
  const { loading, statistics } = props;
  const dispatch = useDispatch();
  const params = { page: 1, limit: 1 };

  const suppliers = useSelector((state) => state.Suppliers.suppliers);
  const users = useSelector((state) => state.Users.users);

  useEffect(async () => {
    await dispatch(fetchSuppliers({ ...params, role: 1 }));
    await dispatch(fetchUsers({ ...params, role: 0 }));
  }, []);

  return (
    <div className="col-md-4 grid-margin">
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-start justify-content-between">
            <p className="card-title flex-grow">Latest Status</p>
          </div>
          {loading ? <Loader /> : null}
          <div className="latest-status">
            <div className="grid-margin col-auto">
              <div
                className="circle-color"
                style={{ backgroundColor: "#E2ECFF" }}
              ></div>
            </div>
            <div className="grid-margin col p-0">
              <p style={{ marginBottom: 0 }}>Total Active Suppliers</p>
              <span>{statistics?.total_new_suppliers || 0} New Supplier</span>
            </div>
            <div
              className="grid-margin col-auto"
              style={{ textAlign: "center" }}
            >
              {statistics?.total_active_suppliers || 0}
            </div>
            <div className="grid-margin col-auto">
              <Link
                to={routes?.APPROVED_SUPPLIERS}
                className="btn btn-fw btn-outline-primary"
                style={{ fontSize: 13, padding: 6, width: 65 }}
              >
                View
              </Link>
            </div>
          </div>

          {/* <div className=" latest-status">
                        <div className="grid-margin col-auto">
                            <div className="circle-color" style={{ backgroundColor: "#CCF5F8"}}></div>
                        </div>
                        <div className="grid-margin col p-0">
                            <p style={{ marginBottom:0}}>Total Active Users</p>
                        </div>
                        <div className="grid-margin col-auto" style={{ textAlign: "center"}}>
                            { statistics?.total_active_users || 0 }
                        </div>
                        <div className="grid-margin col-auto">
                            <Link to={ routes?.USERS}
                                  className="btn btn-fw btn-outline-primary"
                                  style={{ fontSize: 13, padding: 6, width: 65}}
                            >
                                View
                            </Link>
                        </div>
                    </div> */}
          <div className=" latest-status">
            <div className="grid-margin col-auto">
              <div
                className="circle-color"
                style={{ backgroundColor: "#FFDEDE" }}
              ></div>
            </div>
            <div className="grid-margin col p-0">
              <p style={{ marginBottom: 0 }}>Total Registered Users</p>
              {/* <span> { statistics?.total_new_users || 0 } New Users</span> */}
            </div>
            <div
              className="grid-margin col-auto"
              style={{ textAlign: "center" }}
            >
              {statistics?.total_registerd_users || 0}
            </div>
            <div className="grid-margin col-auto">
              <Link
                to={routes?.USERS}
                className="btn btn-fw btn-outline-primary"
                style={{ fontSize: 13, padding: 6, width: 65 }}
              >
                View
              </Link>
            </div>
          </div>
          <div className=" latest-status">
            <div className="grid-margin col-auto">
              <div
                className="circle-color"
                style={{ backgroundColor: "#D2FFE8" }}
              ></div>
            </div>
            <div className="grid-margin col p-0">
              <p style={{ marginBottom: 0 }}>Total Active Categories</p>
              {/* <span>{ statistics?.total_new_categories || 0 } New Category</span> */}
            </div>
            <div
              className="grid-margin col-auto"
              style={{ textAlign: "center" }}
            >
              {statistics?.total_active_categories || 0}
            </div>
            <div className="grid-margin col-auto">
              <Link
                to={routes?.CATEGORIES}
                className="btn btn-fw btn-outline-primary"
                style={{ fontSize: 13, padding: 6, width: 65 }}
              >
                View
              </Link>
            </div>
          </div>
          <div className=" latest-status">
            <div className="grid-margin col-auto">
              <div
                className="circle-color"
                style={{ backgroundColor: "#E2ECFF" }}
              ></div>
            </div>
            <div className="grid-margin col p-0">
              <p style={{ marginBottom: 0 }}>Total Active Products</p>
              {/* <span>{ statistics?.total_new_products || 0 } New Products</span> */}
            </div>
            <div
              className="grid-margin col-auto"
              style={{ textAlign: "center" }}
            >
              {statistics?.total_active_products || 0}
            </div>
            <div className="grid-margin col-auto">
              <Link
                to={routes?.PRODUCTS}
                className="btn btn-fw btn-outline-primary"
                style={{ fontSize: 13, padding: 6, width: 65 }}
              >
                View
              </Link>
            </div>
          </div>
          <div className=" latest-status">
            <div className="grid-margin col-auto">
              <div
                className="circle-color"
                style={{ backgroundColor: "#CCF5F8" }}
              ></div>
            </div>
            <div className="grid-margin col p-0">
              <p style={{ marginBottom: 0 }}>Total Active Promotions</p>
              {/* <span>{ statistics?.total_new_promotions || 0 } New Sales</span> */}
            </div>
            <div
              className="grid-margin col-auto"
              style={{ textAlign: "center" }}
            >
              {statistics?.total_active_promotions || 0}
            </div>
            <div className="grid-margin col-auto">
              <Link
                to={routes?.PROMOTIONS}
                className="btn btn-fw btn-outline-primary"
                style={{ fontSize: 13, padding: 6, width: 65 }}
              >
                View
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
